import {
  LuggageIcon,
  VenusIcon,
  MarsIcon,
  GemIcon,
  BabyIcon,
  HeartPulse,
  SproutIcon,
  DumbbellIcon,
  HelpCircle,
  CableIcon,
  PawPrint,
  type LucideIcon,
} from 'lucide-react';

export const CATEGORIES = {
  'rts.womensFashion': {
    name: 'DS_CATEGORY_WOMENS_FASHION',
    Icon: VenusIcon,
    templateId: 'ca11886c-1135-4156-b799-ca8b8b7442b9',
    templateLangIds: {
      pt: '3622e7f5-9de7-44e7-b993-55c0b8f7c088',
    },
    color: '#FF69B4',
  },
  'rts.mensFashion': {
    name: 'DS_CATEGORY_MENS_FASHION',
    Icon: MarsIcon,
    templateId: 'd74e8fd5-924e-47f7-ab48-e81dc41e1761',
    templateLangIds: {
      pt: '3d57bc33-2b3b-49f2-b66e-eabf510092d9',
    },
    color: '#4169E1',
  },
  'rts.jewelryAccessories': {
    name: 'DS_CATEGORY_JEWELRY_ACCESSORIES',
    Icon: GemIcon,
    templateId: '0a2ea4fb-b93a-4e1a-825d-bbf3b87d0a53',
    templateLangIds: { pt: '44eee06f-9d15-4b3f-9c0e-f7c3ebdf9575' },
    color: '#FFC700',
  },
  'rts.kidsBabies': {
    name: 'DS_CATEGORY_KIDS_BABIES',
    Icon: BabyIcon,
    templateId: 'bc5e01d3-6e5f-426f-bfc3-ca558d22572e',
    templateLangIds: { pt: '56bb8b34-2426-4461-a8f8-cae47ef57120' },
    color: '#00AA8D',
  },
  'rts.beautyHealth': {
    name: 'DS_CATEGORY_BEAUTY_HEALTH',
    Icon: HeartPulse,
    templateId: '049a840e-a63f-4624-8289-ac714cfeb2ec',
    templateLangIds: { pt: '44c2f891-5c61-4f2a-8bc3-363e0e31720a' },
    color: '#FF6B6B',
  },
  'rts.homeGarden': {
    name: 'DS_CATEGORY_HOME_GARDEN',
    Icon: SproutIcon,
    templateId: '7efa4a9a-edc1-4409-87ab-59022aa429a3',
    templateLangIds: { pt: '96572b0c-915e-44c7-8bfa-db9a760a9146' },
    color: '#00D200',
  },
  'rts.sportsEntertainment': {
    name: 'DS_CATEGORY_SPORTS_ENTERTAINMENT',
    Icon: DumbbellIcon,
    templateId: 'b701ba85-4cb1-4496-8262-207ca10d1145',
    templateLangIds: { pt: '3e1ab8e6-ba78-464c-b35a-450422b13fa9' },
    color: '#4682B4',
    // color: '#8700DD',
  },
  'rts.bagsLuggage': {
    name: 'DS_CATEGORY_BAGS_LUGGAGE',
    Icon: LuggageIcon,
    templateId: 'e63c8261-1beb-4131-a5f2-b64222d95690',
    templateLangIds: { pt: 'f4676e63-cf66-463f-81e3-8e3baa443f70' },
    color: '#DEB887',
  },
  'rts.consumerElectronics': {
    name: 'DS_CATEGORY_CONSUMER_ELECTRONICS',
    Icon: CableIcon,
    templateId: 'b13ae6bf-ed09-484d-a708-707c0bd807e7',
    templateLangIds: { pt: 'eb599f69-48f6-4e5b-af46-522ab193fb15' },
    color: '#461bac',
  },
  'rts.pets': {
    name: 'DS_CATEGORY_PETS',
    Icon: PawPrint,
    templateId: '692a105f-c10d-4cc2-9bd6-3df9ca3efb5a',
    templateLangIds: { pt: 'b583ac9f-123a-4889-bac9-86e2c5004e27' },
    color: '#c415f4',
  },
  'rts.chooseForMe': {
    name: 'DS_CATEGORY_CHOOSE_FOR_ME',
    Icon: HelpCircle,
    templateId: '',
    templateLangIds: {},
    color: '#808080',
  },
} as const satisfies Record<
  string,
  { name: string; Icon: LucideIcon; templateId: string; templateLangIds: Record<string, string>; color: string }
>;

export type CategoryKey = keyof typeof CATEGORIES;

export const RANDOM_CATEGORY: CategoryKey = 'rts.chooseForMe';

export const getRandomCategory = (): CategoryKey => {
  const categoryKeys = Object.keys(CATEGORIES).filter((key) => key !== RANDOM_CATEGORY);
  const randomIndex = Math.floor(Math.random() * categoryKeys.length);
  return categoryKeys[randomIndex] as CategoryKey;
};

export const getTemplateIdForCategory = (category: CategoryKey, lang?: string): string => {
  const { templateId, templateLangIds } = CATEGORIES[category];
  if (lang && templateLangIds[lang]) {
    return templateLangIds[lang];
  }
  return templateId;
};

export const CATEGORIES_WITHOUT_COMPONENT_UPDATE = [
  'rts.womensFashion',
  'rts.mensFashion',
  'rts.kidsBabies',
  'rts.homeGarden',
  'rts.beautyHealth',
  'rts.sportsEntertainment',
  'rts.consumerElectronics',
  'rts.jewelryAccessories',
];
